const listColumn = {
  PUBLIC_DATE: 'publicDate', // hh:mm
  TICKER: 'ticker',
  NEWS_ID: 'newsId',
  NEWS_TITLE: 'newsTitle',
  NEWS_SOURCE: 'sourceCode',
};

export default {
  listColumn,
};
